<template>
  <ClassicNtpCommonMostVisitedTitles
    v-if="isListLoaded"
    :is-news-added="true"
    custom-data="outbrain"
    :tiles-list="mostVisited.value"
    provider="AdMarketplace"
    :with-new-design="props.withNewDesign"
  />
</template>

<script setup>
  import { isDevelopment, fetchTileList } from '~~/assets/js/common'

  definePageMeta({
    layout: false,
    pageTransition: false,
  })

  const props = defineProps({
    withNewDesign: {
      type: Boolean,
      default: false,
    },
  })

  const isListLoaded = ref(false)
  const mostVisited = []

  onMounted(async () => {
    const ADM_API = isDevelopment()
      ? 'https://demofeed.tiles.ampfeed.com/tiles?partner=demofeed&sub1=123456789&sub2=placement1&callback=amp_fn&v=1.3&results=5'
      : 'https://olntptiles.tiles.ampfeed.com/tiles?partner=olntptiles&sub1=10173&sub2=newtab&result=10&v=1.3'
    mostVisited.value = await fetchTileList(ADM_API, 'AdMarketplace')
    isListLoaded.value = true
  })
</script>
